import React, { SVGProps } from "react";

export default function SettingsIcon({ color, ...props }: SVGProps<any>) {
  return (
    <svg viewBox="0 0 28 28" width={28} height={28} {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.723}
        transform="translate(1 1.077)"
      >
        <path d="M14.004 22.4l2.805 3.162 4.88-2.74-1.227-4.002 1.275-2.205 4.11-.892v-5.6l-4.11-.892-1.245-2.15 1.258-4.005-4.868-2.77-2.813 3.14h-2.227L9.038.284l-4.881 2.74 1.228 4.002L4.11 9.23 0 10.123v5.6l4.11.892 1.244 2.15-1.257 4.005 4.867 2.77 2.813-3.14z" />
        <circle cx={12.923} cy={12.923} r={4.308} />
      </g>
    </svg>
  );
}
